/**
 * Two decimal places for display/editing, without thousands separators.
 * Safe for controlled inputs — unlike formatTotalBalance, does not insert commas.
 *
 * @param {string|number|null|undefined} value
 * @returns {string} e.g. "122.00", or "" if empty/invalid
 */
const formatAmountTwoDecimals = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(String(value).replace(/,/g, ""));
  if (Number.isNaN(n)) return "";
  return n.toFixed(2);
};

export default formatAmountTwoDecimals;
